<svelte:options runes={false} />
<script>
  // A small, self-contained $100-bill glyph for the Paper-trading banner — inline SVG (no asset file, crisp at
  // any size). Styled to read like a real US "greenback": pale grey-green paper with dark engraving and a faint
  // modern peach tint, NOT a flat dark-green block. The bold red "FAKE" watermark reinforces that paper trading
  // is simulated (no real money), pairing with the "PAPER" badge + "Simulated…" note.
  export let height = 28; // px; width follows the ~2.35:1 banknote aspect ratio
  $: width = Math.round(height * 2.35);
</script>

<svg
  class="fake-bill"
  {width}
  {height}
  viewBox="0 0 235 100"
  role="img"
  aria-label="Fake $100 bill"
  focusable="false"
>
  <defs>
    <!-- Greenback paper: pale grey-green with a faint peach wash on the right (modern $100 note). -->
    <linearGradient id="fb-paper" x1="0" y1="0" x2="1" y2="0.4">
      <stop offset="0" stop-color="#dfe7d8" />
      <stop offset="0.55" stop-color="#e8ead9" />
      <stop offset="1" stop-color="#f0e3d6" />
    </linearGradient>
  </defs>

  <!-- Note body (pale greenback paper) -->
  <rect x="1" y="1" width="233" height="98" rx="7" ry="7" fill="url(#fb-paper)" stroke="#3c5a43" stroke-width="2" />
  <!-- Inner engraved frame -->
  <rect x="8" y="8" width="219" height="84" rx="4" ry="4" fill="none" stroke="#3c5a43" stroke-width="1.4" opacity="0.75" />

  <!-- Corner denominations (dark engraving ink) -->
  <text x="18" y="30" font-family="Georgia, 'Times New Roman', serif" font-size="19" font-weight="700" fill="#2f4a38">100</text>
  <text x="217" y="84" font-family="Georgia, 'Times New Roman', serif" font-size="19" font-weight="700" fill="#2f4a38" text-anchor="end">100</text>

  <!-- Center portrait medallion -->
  <ellipse cx="117.5" cy="50" rx="29" ry="33" fill="#cdd8c4" opacity="0.55" />
  <ellipse cx="117.5" cy="50" rx="29" ry="33" fill="none" stroke="#3c5a43" stroke-width="1.3" opacity="0.7" />
  <circle cx="117.5" cy="42" r="11" fill="#3c5a43" opacity="0.55" />
  <path d="M100 70 q17.5 -19 35 0 z" fill="#3c5a43" opacity="0.55" />

  <!-- Big corner $ (treasury seal nod, faint) -->
  <text x="206" y="40" font-family="Georgia, serif" font-size="24" font-weight="700" fill="#9b6b4a" opacity="0.55" text-anchor="middle">$</text>
  <text x="29" y="78" font-family="Georgia, serif" font-size="24" font-weight="700" fill="#2f4a38" opacity="0.4" text-anchor="middle">$</text>

  <!-- "FAKE" watermark, stamped diagonally across the note -->
  <text
    x="117.5"
    y="58"
    font-family="'Arial Black', Arial, sans-serif"
    font-size="42"
    font-weight="900"
    letter-spacing="2"
    fill="#d12b2b"
    fill-opacity="0.7"
    text-anchor="middle"
    transform="rotate(-18 117.5 50)"
    style="paint-order: stroke; stroke: #ffffff; stroke-width: 2px; stroke-opacity: 0.5;"
  >FAKE</text>
</svg>

<style>
  .fake-bill {
    display: inline-block;
    vertical-align: middle;
    border-radius: 3px;
    flex: none;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
  }
</style>
